import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandHRMonitor(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="m16.989 9.788-5.88-5.88a2 2 0 0 0-2.829 0L3.553 8.635a1.63 1.63 0 0 0 0 2.306L9.695 4.8l6.14 6.141 1.154-1.153Z"
        fill="#7DAF4F"
      />
      <path
        d="m9.695 6.6-5.88 5.88a2 2 0 0 0 0 2.828l4.727 4.727a1.63 1.63 0 0 0 2.306 0l-6.142-6.14 6.142-6.142L9.695 6.6Z"
        fill="#9F2E31"
      />
      <path
        d="m13.754 16.988 5.88-5.88a2 2 0 0 0 0-2.828l-4.727-4.727a1.63 1.63 0 0 0-2.306 0l6.14 6.141-6.14 6.141 1.153 1.153Z"
        fill="#D6903B"
      />
      <path
        d="m6.6 13.824 5.88 5.88a2 2 0 0 0 2.829 0l4.726-4.727a1.63 1.63 0 0 0 0-2.306l-6.14 6.14-6.142-6.14L6.6 13.824Z"
        fill="#55606D"
      />
    </BaseIcon>
  );
}
